export const scrollToTarget = (target) => {
  if (typeof window !== "undefined" && window.__lenis) {
    window.__lenis.scrollTo(target, { offset: -64, duration: 1.5 });
  } else {
    document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
  }
};
